import React from 'react'

const Unsheltered = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M16.4992 5.29926L19.4992 8.29926L17.4992 9.29926L21.4992 13.2993L18.4992 14.2993L22.4992 18.2993H13.4992M15.4992 21.2993V18.2993M8.49922 13.2993L6.49922 11.2993M8.49922 12.2993L10.4992 10.2993M8.49922 21.2993V8.29926M6.32322 16.2993C5.88569 16.2736 5.45909 16.1525 5.07342 15.9443C4.68775 15.7361 4.35239 15.4459 4.09092 15.0941C3.82945 14.7424 3.64823 14.3376 3.55999 13.9083C3.47176 13.479 3.47866 13.0356 3.58022 12.6093C3.21769 12.3074 2.93147 11.9242 2.74481 11.4909C2.55815 11.0577 2.4763 10.5865 2.50592 10.1156C2.53553 9.64478 2.67578 9.18756 2.91526 8.78109C3.15475 8.37462 3.48672 8.03036 3.88422 7.77626C3.53559 7.15692 3.41817 6.43391 3.55288 5.73607C3.68759 5.03823 4.06568 4.41088 4.61978 3.96579C5.17388 3.52071 5.86801 3.28681 6.57848 3.30575C7.28896 3.3247 7.96963 3.59528 8.49922 4.06926C9.02893 3.59603 9.70937 3.32609 10.4194 3.30751C11.1295 3.28893 11.8232 3.52291 12.3769 3.96779C12.9306 4.41268 13.3085 5.03961 13.4434 5.73701C13.5782 6.43441 13.4612 7.15704 13.1132 7.77626C13.5108 8.03027 13.8428 8.37447 14.0824 8.7809C14.322 9.18732 14.4623 9.64453 14.492 10.1154C14.5218 10.5862 14.44 11.0574 14.2534 11.4908C14.0668 11.9241 13.7807 12.3073 13.4182 12.6093C13.5232 13.0501 13.5269 13.5089 13.4292 13.9514C13.3315 14.3938 13.1348 14.8084 12.8539 15.1639C12.573 15.5195 12.2152 15.8068 11.8074 16.0043C11.3996 16.2018 10.9523 16.3044 10.4992 16.3043H6.49922L6.32322 16.2993Z"
      stroke={color}
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export default Unsheltered
